(ns app.bundle-social-pinterest.platform
  "Pinterest boards through bundle.social: a pin with one video or
   image, a title (the story's name unless changed in the options), the
   caption as its description, an optional destination link and
   Pinterest's AI label.

   Only data and pure functions, see `app.bundle-social.platforms` for
   the keys. Every pin names its board (by its name, see `post-data`);
   bundle.social has no set-channel for Pinterest. So the page picker
   offers the boards the OAuth shared, and every picked board becomes a
   Storrito account of its own whose platform id is the board id
   (`:social-platform/post-channel?`)."
  (:require [app.bundle-social.text :as text]))

(defn icon
  "Font Awesome's pinterest-p brand icon."
  [classes]
  [:svg {:xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 384 512"
         :fill "currentColor"
         :aria-hidden "true"
         :class classes}
   [:path {:d "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"}]])

(def max-title-length
  100)

(defn post-data
  "The `data.PINTEREST` entry of a bundle.social post.

   bundle.social names the board by its name (`boardName`) and rejects
   a post without it (verified on prod 2026-10-01, `boardId` is not
   accepted). The push routine reads the board's current name from the
   account's team by the board id that Storrito keeps (`:channel-name`),
   so a board renamed at Pinterest keeps working. The board id
   (`:channel`) itself is not sent.

   Board names are only unique among a user's own boards: a group board
   with the same name as an own board is ambiguous for bundle.social, a
   pin may then land on the other one.

   A video pin gets the story's preview image as its cover
   (`thumbnail`)."
  [{:keys [channel-name title text options upload-id cover-url]}]
  (let [pin-title (or (:title options) (not-empty title))]
    (cond-> {:boardName channel-name
             :uploadIds [upload-id]}
      pin-title
      (assoc :text (text/shorten pin-title max-title-length))

      (seq text)
      (assoc :description text)

      (:link options)
      (assoc :link (:link options))

      cover-url
      (assoc :thumbnail cover-url)

      (:ai-generated options)
      (assoc :isAiGenerated true))))

(def platform
  {:social-platform/id "PINTEREST"
   :social-platform/key :pinterest
   :social-platform/name "Pinterest"
   :social-platform/account-noun "Pinterest board"
   :social-platform/channel-noun "board"
   :social-platform/channel-nouns "boards"
   :social-platform/icon icon
   :social-platform/text-class ["text-red-600"]
   :social-platform/pill-class ["bg-red-50" "border-red-200" "text-red-700"]
   :social-platform/launched? true
   :social-platform/post-channel? true
   :social-platform/connect-card
   {:eyebrow "Video & image pins"
    :description "Connect your Pinterest boards for scheduled video and image pins."
    :button-text "Connect Pinterest"
    :style {:card-class ["border-red-200" "bg-white" "hover:border-red-300"]
            :eyebrow-class ["bg-red-50" "text-red-600" "ring-red-100"]
            :icon-class ["bg-red-600" "text-white" "ring-red-200"]
            :title-class ["text-gray-900"]
            :description-class ["text-gray-600"]
            :button-class ["bg-red-600" "text-white" "hover:bg-red-700"]
            :rail-class ["bg-red-600"]}}
   :social-platform/post-data post-data
   ;; Pinterest takes videos from 4 s to 15 minutes, a description of up
   ;; to 800 characters, and a video pin needs a cover image
   ;; (https://info.bundle.social/api-reference/platforms/pinterest).
   :social-platform/post-types
   [{:post-type/id "PIN"
     :post-type/kind :pinterest-pin
     :post-type/label "Pinterest pin"
     :post-type/group-label "Pinterest"
     :post-type/media #{:video :image}
     :post-type/min-duration-seconds 4
     :post-type/max-duration-seconds 900
     :post-type/caption? true
     :post-type/max-text-length 800
     :post-type/cover? true
     :post-type/cover-required? true
     ;; Decided with Tobias: the title is the media's name unless it is
     ;; changed (2026-10-01); pins can link to a page (2026-09-29).
     :post-type/options
     [{:option/key :title
       :option/type :text
       :option/label "Title"
       :option/max-length max-title-length
       :option/default :media-name
       :option/hint "The pin's headline. Empty uses the media's name."}
      {:option/key :link
       :option/type :url
       :option/label "Destination link"
       :option/hint "Optional. Where the pin leads when someone taps it."}
      ;; Decided with Tobias on 2026-10-01, like Instagram's and TikTok's
      ;; AI label; Pinterest is the only bundle.social platform with one.
      {:option/key :ai-generated
       :option/type :checkbox
       :option/label "AI-generated content"
       :option/hint "Label the pin as AI-generated or AI-modified on Pinterest"}]}]})
